import React from 'react';
import SEOHead from '../seo/SEOHead';
import PageHeader from '../components/PageHeader';

const Donate = () => {
  return (
    <>
      <SEOHead path="/donate" />
      <PageHeader title="Give Hope — Donate Today" breadcrumb="Donate" />

      <section className="section">
        <div className="container">
          <div className="section-header">
            <span className="overline">Support Our Mission</span>
            <h2>Your Generosity Changes Lives</h2>
            <p>Every donation helps us reach those whom no one else reaches. Choose your preferred method below.</p>
          </div>

          <div className="donate-grid fade-in">
            <div className="donate-card">
              <img
                src="/images/paypal.svg"
                alt="PayPal"
                style={{ height: '40px' }}
              />
              <h3>PayPal</h3>
              <p>Send a one-time or recurring donation through PayPal.</p>
              <a
                href="https://www.paypal.com"
                target="_blank"
                rel="noopener noreferrer"
                className="donate-btn"
              >
                Donate with PayPal
              </a>
            </div>

            <div className="donate-card">
              <a href="https://donorbox.org/teenchallengearmenia" target="_blank" rel="noopener noreferrer">
                <img
                  src="/images/cards.png"
                  alt="Credit Card Donations via Stripe"
                  style={{ height: '60px' }}
                />
              </a>
              <h3>Credit / Debit Card</h3>
              <p>Send a one-time or recurring donation via Stripe through Donorbox.</p>
              <a
                href="https://donorbox.org/teenchallengearmenia"
                target="_blank"
                rel="noopener noreferrer"
                className="donate-btn"
              >
                Donate with Card
              </a>
            </div>

            <div className="donate-card">
              <img
                src="/images/zelle.png"
                alt="Zelle"
                style={{ height: '50px' }}
              />
              <h3>Zelle</h3>
              <p>Use your bank's app and send to:</p>
              <p style={{ fontWeight: 700, color: 'var(--navy)', fontSize: '13px', wordBreak: 'break-all' }}>contact@teenchallengearmenia.org</p>
            </div>
          </div>

          <div className="donate-message fade-in">
            <p>We sincerely appreciate all of your supports without which we couldn't have done this. Every morning we remember you in our prayer meetings proclaiming blessings upon your families and finances, praying for you to have a good health. We believe that God will use the seeds you are planting and the changed lives of our students, to expand our activity and reach even more people.</p>
            <p style={{ marginTop: '16px', fontWeight: 700, color: 'var(--gold-dark)', fontStyle: 'normal' }}>Thanks and Blessings!!!</p>
          </div>
        </div>
      </section>
    </>
  );
};

export default Donate;
